import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from "../../../../app/ui/modal/v4/v4";

import FormManager from 'src/core/gd-form/common/form-manager';
import FormError from 'src/core/gd-form/common/form-error/form-error';
import Input from 'core/gd-form/form-element/input/input';
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import ButtonSubmit2 from "core/gd-form/common/btn-submit/btn-submit-2";

class ModalCRMInvite extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            contact: PropTypes.object,

            onSubmit: PropTypes.func
        })
    }

    constructor(props) {
        super(props);

        const initFormData = {
            email: props.params.contact.email
        };

        const formStructure = {
            fields: {
                email: {
                    type: 'input',
                    isRequired: true,
                    validator: value=>{
                        return gd.utils.validateEmail(value) ? true : 'Email is invalid';
                    }
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.params.onSubmit(result);
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ModalV4HeaderWhite height={60} title='Invite to GoodDay'/>
                <div className="ui5-form size-30-70 modal">
                    <div className="f-tbl">
                        <FormRow label="Email">
                            <Input size="big" form={this.form} name="email" />
                            <FormError form={this.form} name="email" />
                        </FormRow>
                    </div>

                    <div className="fl-ac fl-jc m-t-30">
                        <ButtonSubmit2 form={this.form} label="Invite"/>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = ModalCRMInvite;